import { TEST_MOBILE_NUMBER } from '../schemas/enums';
import { orderSchema } from '../schemas/order/orderSchema';
import { todayAt } from '../utils/todayAt';

/**
 * An order placed via 'consumer-web'.
 * - Payment "Cash in store"
 */
export const ordersWebsiteToBePaidInStore = orderSchema
  .pick({
    platform: true,
    status: true,
    payments: true,
    customerName: true,
    customerEmail: true,
    customerPhoneNumber: true,
    fullyPaidAt: true,
  })
  .decode({
    platform: 'CONSUMER_WEB',
    status: 'SUBMITTED',
    // Not paid, as customer will "pay in store"
    payments: [],
    fullyPaidAt: null,
    customerName: 'Johnny Cash',
    customerEmail: 'johnc@gmail.com',
    customerPhoneNumber: TEST_MOBILE_NUMBER.AU_0477_123_456,
  });

/**
 * An order placed via 'consumer-web'.
 * - Paid by credit card (Stripe)
 */
export const ordersWebsitePaidByCard = orderSchema
  .pick({
    platform: true,
    status: true,
    customerName: true,
    customerPhoneNumber: true,
    fullyPaidAt: true,
    isClosed: true,
  })
  .decode({
    platform: 'CONSUMER_WEB',
    status: 'SUBMITTED',
    customerName: 'Test Customer',
    customerPhoneNumber: TEST_MOBILE_NUMBER.AU_0477_123_456,
    // All orders paid online need to be fully paid
    fullyPaidAt: todayAt('10:03'),
    // Even though the order is fully paid, it should remain open
    isClosed: false,
  });
